import React, { useState } from "react";
// import alertIcon from "../../../images/alert.png";
import useStyles from "../../../components/common/model/styles";
import Popup from "../../../components/common/model/Popup";
import { Alert, DialogContent, DialogContentText } from "@mui/material";
import closeIcon from "../../../assets/closeModel.png";
import CustomButton from "../../../components/common/button/CustomButton";

interface AlertCloseLeadProps {
  open: boolean;
  title?: string;
  onHide?: () => void;
  content?: any;
  isError?: any;
  setIsValid?: any;
  setAlertModelShow?: any;
  // submitHandler?: () => void;
}

const AlertCloseLead: React.FC<AlertCloseLeadProps> = ({
  open,
  title,
  onHide = () => {},
  content,
  setIsValid,
  isError,setAlertModelShow
  // submitHandler = () => {}
}) => {
  const classes = useStyles();

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("xs"); // Adjust the type definition

  const submitHandler = () => {
    onHide();
  };
  const closeModel =() =>{
    setAlertModelShow(false);
  }
  return (
    <Popup
      open={open}
      title={title || ""}
      onHide={onHide}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={closeModel}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      footer={
        <>
          {isError ? (
            <CustomButton variant="outlined" title="Close" onClick={closeModel} />
          ) : (
            <>
              <CustomButton variant="outlined" title="No" onClick={closeModel} />
              <CustomButton title="Yes" onClick={submitHandler} />
            </>
          )}
        </>
      }
    >
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText>
          <>
            <Alert
              sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
              severity="warning"
            >
              You have unsaved changes. If you close this model, your changes will be lost. Are you sure you want to proceed?
            </Alert>
          </>
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default AlertCloseLead;
